// extracted by mini-css-extract-plugin
module.exports = {"image":"jgp-3wlIP","name":"jgp-2Cmau","logoWrapper":"jgp--DT7J","logoImage":"jgp-1wbAb"};